import { t } from "i18next";
import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>{t("about")}</h2>
              {/* <p>{t("about_text")}</p> */}
              <p>
                جبتكو شركة متخصصه في البرامج المحاسبيه وتقنية المعلومات العامة
                مملوكة لشركة فخر العراقة لتقنية المعلومات التي تم تأسيسها في
                المملكة العربية السعودية . جبتكو لديها خبرة واسعة في عمل البرامج
                الحسابيه الي اكتسبتها خلال سنوات عديدة من المشاركة في هذه
                الصناعة. نحن من بين المساهمين الذين يصوغون معايير التكنولوجيا
                المستقبلية و برامج <p style={{ display: "inline" }}>ERP</p> في المملكة العربية السعودية والشرق الأوسط
                ، ،نحن نقدم فريق متخصص من خبراء تكنولوجيا المعلومات , و
                المحاسبين ذوي الخبرة ونقدم خدماتنا إلى مجموعة واسعة من العملاء
                من الشركات و المصانع والقطاع العام وقطاع التجزئة والتعليم في
                جميع أنحاء منطقة الشرق الأوسط وشمال إفريقيا. لدينا القدرة
                المعترف بها لتقديم الخدمات والحلول المحاسبيه ، التي تناسب
                الاحتياجات الفريدة لكل مؤسسة وفقا لحجمها ومجال نشاطها
              </p>
              {/* <h3>Why Choose Us?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
